module.exports = __webpack_public_path__ + "img/agave_4.587c05fa.jpeg";